@if (entry(); as entry) {
  <div class="waiting-list">
    @if (entry?.priority) {
      <div class="queue-prioritary">
        <mat-icon color="primary">star</mat-icon>
        {{ 'PORTAL.WAITING_LIST.SUCCESS.PRIORITY' | translate }}
        <mat-icon color="primary">star</mat-icon>
      </div>
    }
    <h1>{{ 'PORTAL.QUEUE.TABLE_FOR' | translate }} {{ entry.count }}</h1>
    <!-- if has tableGroupId, it means the customer already was seated to some table -->
    @if (!!entry.tableGroupId) {
      <!--  -->
      <h3>{{ 'PORTAL.QUEUE.WAIT_ENDED' | translate }}</h3>
      <p>{{ entry.name }}, {{ 'PORTAL.QUEUE.TABLE_WAITING' | translate }}</p>
      <p>{{ 'PORTAL.QUEUE.ENJOY_AND_RATE' | translate }}</p>
    } @else {
      <div>
        <span class="waiting-list-position">
          {{ entry.position }}
        </span>
      </div>
      <!--  -->
      <p class="queue">
        {{ 'PORTAL.QUEUE.HELLO' | translate }} {{ entry.name }},
        {{ 'PORTAL.QUEUE.POSITION_IS' | translate }}
      </p>
      <p>{{ 'PORTAL.QUEUE.SMS_SENT' | translate }}</p>
      <p>
        {{ 'PORTAL.QUEUE.CALL_MESSAGE' | translate }} {{ entry.phone | countryPhone }}
        {{ 'PORTAL.QUEUE.CALL_WHEN_READY' | translate }}
      </p>
      <p class="tolerance">{{ 'PORTAL.QUEUE.TOLERANCE' | translate }}</p>
      <div class="button-group">
        <button mat-stroked-button type="button" (click)="onViewMenu()">
          {{ 'PORTAL.QUEUE.VIEW_MENU' | translate }}
        </button>
        <button
          mat-stroked-button
          type="button"
          (click)="this.leaveQueue.emit()"
          [disabled]="portalDataService.isLoadingExitQueue()">
          @if (portalDataService.isLoadingExitQueue()) {
            <div class="c-btn-spinner">
              <mat-spinner class="c-btn-spinner__spinner" color="primary"></mat-spinner>
              <span>{{ 'PORTAL.QUEUE.LEAVING_QUEUE' | translate }}</span>
            </div>
          } @else {
            <span>{{ 'PORTAL.QUEUE.EXIT_QUEUE' | translate }}</span>
          }
        </button>
      </div>
    }
  </div>
}
